module.exports = __webpack_public_path__ + "assets/img/0-12.5259e3ea.svg";